import styled from 'styled-components';

export const Container = styled.section`
    max-width: 1220px; // 1108 + (padding-left + padding-right)
    width: 100%;
    margin: 0 auto;
    padding: 0 56px;
`;

export const ConditionalWrap = ({condition, wrap, fallback, children}) => {
    return condition ? wrap(children) : fallback ? fallback(children) : children;
}